import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Truncate from 'react-truncate';

import cls from 'classnames/bind';

import Money from '@ott/money';
import StarRating from '@ott/star-rating';
import declOfNum from '@ott/utility-decl-of-num';

import CalendarIcon from '../../icons/CalendarIcon';
import PeopleIcon from '../../icons/PeopleIcon';

import styles from './HotTourCard.scss';

const cx = cls.bind(styles);

const formatDate = Intl.DateTimeFormat('ru', {
  day: 'numeric',
  month: 'long',
}).format;
const nightsDecl = ['ночь', 'ночи', 'ночей'];
const personsDecl = ['человека', 'человек', 'человек'];

class HotTourCard extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      cityFrom: PropTypes.string,
      cityTo: PropTypes.string,
      countryTo: PropTypes.string,
      dateFrom: PropTypes.string,
      nights: PropTypes.number,
      hotel: PropTypes.string,
      priceNew: PropTypes.number,
      priceOld: PropTypes.number,
      discount: PropTypes.number,
      visaTo: PropTypes.string,
      fullText: PropTypes.string,
      persons: PropTypes.number,
      picture: PropTypes.string,
    }),
    hasOverlay: PropTypes.bool,
    showImages: PropTypes.bool,
  };

  static defaultProps = {
    data: {},
    hasOverlay: true,
    showImages: false,
  };

  getHotelId() {
    const { data } = this.props;
    const parseResult = /hotel_id=(\d*)/.exec(data.link);

    return parseResult && parseResult[1];
  }

  handleClick = () => {
    const { data, trackEvent } = this.props;

    trackEvent('cardClick', {
      from: data.cityFrom,
      to: data.cityTo,
      date_from: data.dateFrom,
      nights: data.nights,
      hotel_id: this.getHotelId(),
      price: data.priceNew,
      old_price: data.priceOld,
      discount: data.discount,
      visa: data.visa,
      tourist_count: data.persons,
    });
  };

  getImage = (url) => `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${url})`;

  render() {
    const { data, className, hasOverlay, showImages } = this.props;

    return (
      <a
        className={cx('HotTourCard', className)}
        href={`https://www.onetwotrip.com/ru/tours${data.link}`}
        onClick={this.handleClick}
        target="_blank"
        rel="noreferrer"
      >
        <div
          className={cx('head')}
          style={{
            backgroundImage: this.getImage(showImages ? data.picture : ''),
          }}
        >
          <div className={cx('head-row')}>
            <div className={cx('to')}>
              {data.cityTo}, {data.countryTo}
            </div>
            <div className={cx('discount')}>-{data.discount}%</div>
          </div>

          <div className={cx('head-row')}>
            <div className={cx('from')}>{data.cityFrom}</div>
            <div className={cx('visa')}>{data.visaTo}</div>
          </div>
        </div>

        <div className={cx('body')}>
          <div className={cx('stars')}>
            <StarRating rating={data.hotelStars} />
          </div>
          <div className={cx('hotel')}>{data.hotel}</div>

          <div className={cx('description')}>
            <Truncate lines={5}>{data.fullText}</Truncate>
          </div>

          <div className={cx('divider')} />

          <div className={cx('body-row')}>
            <div className={cx('date')}>
              <CalendarIcon className={cx('icon')} w={16} h={16} fill="#212121" />
              {formatDate(new Date(data.dateFrom))} / {data.nights}{' '}
              {declOfNum(data.nights, nightsDecl)}
            </div>
            <div className={cx('oldPrice')}>
              <Money amount={data.priceOld} />
            </div>
          </div>

          <div className={cx('body-row', 'body-row--isCentered')}>
            <div className={cx('persons')}>
              <PeopleIcon className={cx('icon')} w={16} h={16} fill="#212121" />
              На {data.persons} {declOfNum(data.persons, personsDecl)}
            </div>
            <div className={cx('price')}>
              <Money amount={data.priceNew} />
            </div>
          </div>
        </div>

        {hasOverlay && <div className={cx('overlay')} />}
      </a>
    );
  }
}

export default HotTourCard;
